import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TN2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TN2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_765)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#E31D1C"
        />
        <mask
          id="mask0_1813_765"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="18"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_765)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 15C15.3137 15 18 12.3137 18 9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9C6 12.3137 8.68629 15 12 15Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0519 13.2381C13.0519 13.2381 9.88961 12.3754 9.88961 8.98014C9.88961 5.5849 13.0519 4.6482 13.0519 4.6482C11.7443 4.1421 7.91749 4.91863 7.91749 8.98014C7.91749 13.0416 11.851 13.7731 13.0519 13.2381ZM12.8777 8.24133L11.3088 8.81457L12.9951 9.40399L13.0518 10.9827L14.078 9.75623L15.7701 9.87633L14.551 8.88172L15.2852 7.4454L13.851 7.92813L12.8574 6.68619L12.8777 8.24133Z"
            fill="#E31D1C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_765">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TN2418Icon;
